import {PlaceholderComponent} from '../shared/placeholder.component';
import {FloorFormComponent} from './floor-form.component';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'building.edit.floor',
    abstract: true,
    component: PlaceholderComponent,
    future: true,
    data: {
      pageTitle: 'states.floor.pageTitle',
      scopes: ['floor:read']
    }
  },
  {
    name: 'building.edit.floor.add',
    component: FloorFormComponent,
    future: true,
    data: {
      pageTitle: 'states.floor.add.pageTitle',
      scopes: ['floor:create']
    }
  },
  {
    name: 'building.edit.floor.edit',
    component: FloorFormComponent,
    future: true,
    data: {
      pageTitle: 'states.floor.edit.pageTitle',
      scopes: ['floor:update']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class FloorRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/floor/floor.routes.ts